<script>
  import { format } from 'svelte-i18n';
  import { Button, Modal, ModalBody, ModalFooter } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { AD_TYPES, LINK_TYPES } from '@client/enums';

  import { AdForm } from '../shared';

  export let show = false;
  export let showNextModal = false;
  export let showPreviousModal = false;
  export let adData = {};

  let linktype = LINK_TYPES.url.id;
  let adtype = AD_TYPES.image.id;
  let url = '';
  let textString = '';
  let textCss = '';
  let fileData = {};
  let files = [];
  let alttext = '';
  let validationError = false;
  let selectedDocuments = '';
  let selectedVideos = '';
  let inline = false;
  let is2x = false;
  let isPlaceholder = false;
  let countInternal = false;
  let disableViews = false;

  const onGoBack = () => {
    show = false;
    setTimeout(() => (showPreviousModal = true), 200);
  };

  const onCloseModal = () => {
    adData = {};
    linktype = LINK_TYPES.url.id;
    adtype = AD_TYPES.text.id;
    url = '';
    textString = '';
    textCss = '';
    fileData = {};
    files = [];
    alttext = '';
    validationError = false;
    selectedDocuments = '';
    selectedVideos = '';
    inline = false;
    is2x = false;
    isPlaceholder = false;
    countInternal = false;
    disableViews = false;
    show = false;
  };

  const onKeyUp = (event) => {
    if (event.key === 'Escape') {
      onCloseModal();
    }
  };

  const onShowNextModal = () => {
    adData = {
      ...adData,
      linktype,
      url: linktype === LINK_TYPES.url.id ? url : null,
      docinfo:
        linktype === LINK_TYPES.doc.id
          ? {
              filename: selectedDocuments?.filename,
              filesize: selectedDocuments?.filesize,
              hash: selectedDocuments?.hash,
              noncompliant: selectedDocuments?.noncompliant,
              rulename: selectedDocuments?.rulename,
              viewonly: selectedDocuments?.viewonly,
              _id: selectedDocuments?._id
            }
          : null,
      docname: LINK_TYPES.doc.id ? selectedDocuments?.rulename : null,
      videoinfo: LINK_TYPES.video.id
        ? {
            duration: selectedVideos?.duration,
            height: selectedVideos?.height,
            rulename: selectedVideos?.rulename,
            thumbnail: selectedVideos?.thumbnail,
            title: selectedVideos?.title,
            url: selectedVideos?.url,
            videotype: selectedVideos?.videotype,
            vidid: selectedVideos?.vidid,
            width: selectedVideos?.width,
            _id: selectedVideos?._id
          }
        : null,
      videoname: LINK_TYPES.video.id ? selectedVideos?.rulename : null,
      adtype,
      textstring: adtype === AD_TYPES.text.id ? textString : null,
      textcss: adtype === AD_TYPES.text.id ? textCss : null,
      filename: adtype === AD_TYPES.image.id ? fileData?.filename || null : null,
      filesize: adtype === AD_TYPES.image.id ? fileData?.filesize || null : null,
      hash: adtype === AD_TYPES.image.id ? fileData?.hash || null : null,
      metadata: adtype === AD_TYPES.image.id ? fileData?.metadata || null : null,
      mimetype: adtype === AD_TYPES.image.id ? fileData?.metadata?.mimetype || null : null,
      alttext: adtype === AD_TYPES.image.id ? alttext || null : null,
      inline: adtype === AD_TYPES.image.id ? inline : null,
      is2x: adtype === AD_TYPES.image.id ? is2x : null,
      isplaceholder: adtype === AD_TYPES.image.id ? isPlaceholder : null,
      countinternal: countInternal,
      disableviews: disableViews
    };

    show = false;
    setTimeout(() => (showNextModal = true), 200);
  };

  $: isDisabled =
    (linktype === LINK_TYPES.url.id && (validationError || !url.length)) ||
    (linktype === LINK_TYPES.doc.id && !Object.keys(selectedDocuments).length) ||
    (linktype === LINK_TYPES.video.id && !Object.keys(selectedVideos).length) ||
    (adtype === AD_TYPES.text.id && !Object.keys(textString).length) ||
    (adtype === AD_TYPES.image.id && !files.length);
</script>

<Modal bind:isOpen={show} size="lg" fullscreen="lg" scrollable>
  <ModalBody class="campaign-modal">
    <div class="modal-actions">
      <button class="back" on:click={onGoBack}>
        <Icon name="arrow-left" />
        <span>{$format('label.BACK')}</span>
      </button>

      <button class="close" on:click={onCloseModal}>
        <Icon name="x" />
      </button>
    </div>

    <div>
      <h1>{$format('label.AD_SETUP')}</h1>
      <p>{$format('label.DESCRIPTION.AD_SETUP_MODAL')}</p>
    </div>

    <div class="modal-body">
      <AdForm
        bind:linktype
        bind:adtype
        bind:url
        bind:textString
        bind:textCss
        bind:fileData
        bind:files
        bind:alttext
        bind:validationError
        bind:selectedDocuments
        bind:selectedVideos
        bind:inline
        bind:is2x
        bind:isPlaceholder
        bind:countInternal
        bind:disableViews
      />
    </div>
  </ModalBody>
  <ModalFooter>
    <Button id="modal-next-btn" color="primary" on:click={onShowNextModal} disabled={isDisabled}>
      {$format('label.NEXT')} <Icon name="arrow-right" />
      {$format('label.TARGETING')}
    </Button>
  </ModalFooter>
</Modal>

<svelte:window on:keyup={onKeyUp} />

<style lang="scss" src="./ad.scss"></style>
